import type { PartnershipAdSettingFormValue } from '../components/PartnershipSection';

export const createDefaultPartnershipAdSetting = (): PartnershipAdSettingFormValue => ({
  partnershipId: '',
  partnershipTag: '',
  partnershipPartnerPageId: '',
  partnershipAppPageId: '',
  partnershipPartnerInstagramId: null,
});
